import { useMap } from 'react-leaflet';
import { useEffect } from 'react';

interface MapRecenterProps {
  center: [number, number];
}

const MapRecenter: React.FC<MapRecenterProps> = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.flyTo(center, map.getZoom());
    }
  }, [center, map]);
  return null;
};

export default MapRecenter;
